import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';
import { getIcon } from '../iconMap';

function ClubsGrid({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page">
        <Reveal className="max-w-2xl">
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
        </Reveal>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((c, i) => {
            const I = getIcon(c.icon);
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div className="group p-6 bg-white rounded-2xl border border-olive/10 hover:border-accent/40 hover:shadow-soft transition">
                  <div className="flex items-center gap-3">
                    <I className="text-accent" size={24} />
                    <EditableText value={c.name} onChange={(t) => updateItem(i, { name: t })} as="h4" className="font-semibold text-olive-deep" />
                  </div>
                  <EditableText value={c.detail} onChange={(t) => updateItem(i, { detail: t })} as="p" multiline className="mt-3 text-sm text-ink/70 leading-relaxed" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ClubsGrid;
